module.exports = __webpack_public_path__ + "img/verify-icon@2x.010130ba.png";